export const GUTHABEN_DISCOUNT_REASON = 'Guthaben';
